export default "/assets/images/graph-pet-dander.d2d43b40eaa6c92a.png";